import { render, staticRenderFns } from "./EcommerceLayout.vue?vue&type=template&id=fa86f00e&"
import script from "./EcommerceLayout.vue?vue&type=script&lang=ts&"
export * from "./EcommerceLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports